var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconNotificationActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.2002 24C12.6389 24 13.8778 23.131 14.4214 21.8906H7.979C8.52261 23.131 9.76157 24 11.2002 24Z",
    fill: "url(#paint0_linear_1404_14386)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M18.4659 11.6185V10.0781C18.4659 6.80522 16.2904 4.0312 13.3096 3.12516V2.10938C13.3096 0.946266 12.3634 0 11.2003 0C10.0371 0 9.09088 0.946266 9.09088 2.10938V3.12516C6.11009 4.0312 3.93463 6.80517 3.93463 10.0781V11.6185C3.93463 14.4935 2.83878 17.2195 0.848984 19.2946C0.653984 19.4979 0.599188 19.798 0.709719 20.0571C0.82025 20.3162 1.07478 20.4844 1.3565 20.4844H21.044C21.3257 20.4844 21.5802 20.3162 21.6907 20.0571C21.8013 19.798 21.7465 19.4979 21.5515 19.2946C19.5617 17.2195 18.4659 14.4934 18.4659 11.6185ZM11.9034 2.84663C11.672 2.82431 11.4374 2.8125 11.2003 2.8125C10.9631 2.8125 10.7285 2.82431 10.4971 2.84663V2.10938C10.4971 1.72167 10.8125 1.40625 11.2003 1.40625C11.588 1.40625 11.9034 1.72167 11.9034 2.10938V2.84663Z",
    fill: "url(#paint1_linear_1404_14386)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M20.3409 10.0778C20.3409 10.4661 20.6557 10.7809 21.0441 10.7809C21.4324 10.7809 21.7472 10.4661 21.7472 10.0778C21.7472 7.26061 20.6501 4.61204 18.6581 2.61999C18.3835 2.34544 17.9383 2.3454 17.6637 2.61999C17.3891 2.89458 17.3891 3.33976 17.6637 3.61435C19.3902 5.3408 20.3409 7.63622 20.3409 10.0778Z",
    fill: "url(#paint2_linear_1404_14386)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M1.35645 10.7809C1.74476 10.7809 2.05957 10.4661 2.05957 10.0778C2.05957 7.63624 3.01038 5.34082 4.73679 3.61437C5.01138 3.33977 5.01138 2.8946 4.73679 2.62001C4.46224 2.34541 4.01702 2.34541 3.74243 2.62001C1.75038 4.61205 0.65332 7.26059 0.65332 10.0778C0.65332 10.4661 0.968133 10.7809 1.35645 10.7809Z",
    fill: "url(#paint3_linear_1404_14386)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1404_14386",
    x1: 11.2002,
    y1: 21.8906,
    x2: 11.2002,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF970"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E68A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1404_14386",
    x1: 11.2002,
    y1: -6.10482e-7,
    x2: 11.2002,
    y2: 20.4844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF970"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E68A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1404_14386",
    x1: 19.6025,
    y1: 2.41406,
    x2: 19.6025,
    y2: 10.7809,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF970"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E68A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1404_14386",
    x1: 2.79803,
    y1: 2.41406,
    x2: 2.79803,
    y2: 10.7809,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF970"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E68A00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNotificationActive);
export default __webpack_public_path__ + "static/media/icon_notification_active.cef6c2fb52862c1fe1e7df8b87ce4230.svg";
export { ForwardRef as ReactComponent };